let reset_form_action = (actionData) => {
    window.Smart.utils.reset_form(actionData.formId);
};
export default reset_form_action;
